import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

import { captureMessageForSentry } from '@/helpers/sentry-helper';
import { ClassicUrl, handleClickoutUrl } from '@/helpers/clickout-helper';
import { useLanguageStore } from '@/helpers/composables/useStores';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClickoutAnchor',
  props: {
    href: null,
    rel: { default: 'noopener' },
    enableSkip: { type: Boolean, default: true }
  },
  emits: ["click"],
  setup(__props: any, { emit: emits }: { emit: ({ (e: 'click', event: MouseEvent): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { href: string, rel: string, enableSkip: boolean };





const anchor = ref<HTMLAnchorElement | null>(null);

const { country } = useLanguageStore();
const disableUctSkip = computed(() => country.value !== 'CA');

// The non-UCT, non-adblockable link that is allowed in the HTML.
// Fallback to the UCT link so that worst case there's still something.
const offerUrl = computed(() => {
	// extra safety
	if (props.href == null) return '';

	// return the directly affiliated link
	if (!props.enableSkip || disableUctSkip.value) return props.href;

	return new ClassicUrl(props.href).get('r') ?? props.href;
});

async function handleClick(clickoutUrl: string, event: MouseEvent) {
	emits('click', event);

	if (!props.enableSkip || disableUctSkip.value) return;

	event.preventDefault();

	// extra safety
	if (props.href == null) return;

	if (anchor.value == null) {
		captureMessageForSentry(
			`[ClickoutAnchor] Error getting the final Clickout URL.`,
			{
				where: '[ClickoutAnchor.vue] handleClick()',
				error: new Error('Anchor DOM node not found.'),
				meta: { clickoutUrl: props.href, offerUrl: offerUrl.value },
			},
			'error'
		);
	}

	// if argument 3 (AKA `windowFeatures`) has anything other than just 'noopener', it'll open as a popup
	window.open(
		await handleClickoutUrl(clickoutUrl, props.enableSkip),
		'_blank',
		'nofollow noopener sponsored popup=false'
	);
}

return { __sfc: true,props, emits, anchor, country, disableUctSkip, offerUrl, handleClick }
}

})